module.exports = __webpack_public_path__ + "img/20190625161627995.1ae6ec2e.png";